import * as React from 'react';

import QuestionsAndAnswers from '../QuestionsAndAnswers'

import SubjectPageTeacherCenterArticles from '../../components/content_hubs/subject_page_teacher_center_articles'
import { LARGE_ICON_BASE_SRC, EXTRA_LARGE_ICON_BASE_SRC } from '../../../Shared/index'
import { DEDICATED_PRACTICE_IS_AN_INVESTMENT_ID, ENCOURAGE_STUDENT_WORK_AT_OWN_PACE_ID, TERROR_OUT_OF_GRAMMAR_ID } from '../../utils/subjectPages';
import { useClearHashOnReturn } from '../../hooks/useClearHashOnReturn';

const studentPencilSrc = `${LARGE_ICON_BASE_SRC}/student-pencil.svg`
const districtSrc = `${EXTRA_LARGE_ICON_BASE_SRC}/district.svg`
const texasSrc = `${EXTRA_LARGE_ICON_BASE_SRC}/texas.svg`
const clipboardSrc = `${EXTRA_LARGE_ICON_BASE_SRC}/clipboard-alt.svg`

function courseCard({label, link, active}) {
  const buttonClass = `quill-button focus-on-light contained medium green ${active ? '' : 'disabled'}`
  const buttonLabel = active ? 'View Activity Packs' : 'Coming Soon'
  return(
    <div className="course-card">
      <img alt="" src={studentPencilSrc} />
      <div>
        <h2>{label}</h2>
      </div>
      <a className={buttonClass} href={link}>{buttonLabel}</a>
    </div>
  )
}

const summary = (
  <section className="summary-section">
    <div className="container">
      <h2>Effective Writing Solutions for Texas Districts</h2>
      <div className="summary-items">
        <div className="summary-item">
          <img alt="" src={districtSrc} />
          <h3>Align with TEKS Standards</h3>
          <p>Provide rigorous, year-long writing instruction through weekly TEKS-aligned activities.</p>
        </div>
        <div className="summary-item">
          <img alt="" src={texasSrc} />
          <h3>Write about Texas</h3>
          <p>Explore Texas-themed activities on the Dust Bowl, rodeos, NASA, democracy, and more.</p>
        </div>
        <div className="summary-item">
          <img alt="" src={clipboardSrc} />
          <h3>Improve STAAR Performance</h3>
          <p>Build the revising and editing skills students need to succeed on STAAR.</p>
        </div>
      </div>
    </div>
  </section>
)

const teacherQuotes = (
  <section className="teacher-quotes">
    <div className="container">
      <h2>What Are Texas Teachers Saying?</h2>
      <div className="quote-boxes">
        <div className="quote-box">
          <p>“We have seen students grow in their confidence in English faster with Quill than with Amplify, i-Ready, or Lexia English.”</p>
          <div>
            <span className="name">Lilo B., ESL Coordinator</span>
            <span>Judson ISD</span>
          </div>
        </div>
        <div className="quote-box">
          <p>“Quill gives my students the confidence they need to self-edit, peer-edit, and look at writing in a clearer context.”</p>
          <div>
            <span className="name">Lynn B., English Teacher</span>
            <span>Amarillo ISD</span>
          </div>
        </div>
        <div className="quote-box">
          <p>"Quill activities are very aligned with our standardized testing. A lot of our [emergent bilingual] students find themselves struggling with these tests. Quill is a low-stakes environment to practice.”</p>
          <div>
            <span className="name">Alyssa M., ELA Teacher</span>
            <span>Donna ISD</span>
          </div>
        </div>
      </div>
    </div>
  </section>
)

const TeksPage = ({}) => {
  useClearHashOnReturn();

  const basePath = window.location.pathname
  const formatLink = (path: string) => `${basePath}/${path}`.replace('//', '/')

  const TEKS_COURSES = [
    { link: formatLink('third-grade'), label: '3rd Grade', active: true },
    { link: formatLink('fourth-grade'), label: '4th Grade', active: true },
    { link: formatLink('fifth-grade'), label: '5th Grade', active: true },
    { link: formatLink('sixth-grade'), label: '6th Grade', active: true },
    { link: formatLink('seventh-grade'), label: '7th Grade', active: true },
    { link: formatLink('eighth-grade'), label: '8th Grade', active: true },
    { link: formatLink('english-i'), label: 'English I', active: true },
    { link: formatLink('english-ii'), label: 'English II', active: true },
  ]

  const overview = (
    <header>
      <div className="container">
        <h1>Quill for Texas</h1>
        <p className="subtext">Support rigorous literacy instruction with TEKS-aligned writing practice designed to build STAAR readiness.</p>
        <div className="course-cards">
          <div className="course-card-column">
            {TEKS_COURSES.slice(0, 4).map(course => courseCard(course))}
          </div>
          <div className="course-card-column">
            {TEKS_COURSES.slice(4).map(course => courseCard(course))}
          </div>
        </div>
      </div>
    </header>
  )

  const tryItOutForYourself = (
    <section className="try-it-out">
      <div className="container">
        <h2>Try it out for yourself</h2>
        <div className="links-wrapper">
          <a className="quill-button focus-on-dark outlined green large" href="https://www.quill.org/proofreader#/play/pf?anonymous=true&uid=378fa82e-f3a8-4043-b1be-cb98a73200f0" rel="noopener noreferrer" target="_blank" >Try a sample activity</a>
          {TEKS_COURSES.map(course => (
            <a className="quill-button focus-on-dark outlined green large" href={course.link} key={course.link} rel="noopener noreferrer" target="_blank" >{course.label} Activity Packs</a>
          ))}
        </div>
      </div>
    </section>
  )

  return (
    <main className="teks-page subject-page">
      {overview}
      {summary}
      {teacherQuotes}
      <QuestionsAndAnswers questionsAndAnswersFile="teks" supportLink={null} />
      <SubjectPageTeacherCenterArticles blogPostIds={[TERROR_OUT_OF_GRAMMAR_ID, DEDICATED_PRACTICE_IS_AN_INVESTMENT_ID, ENCOURAGE_STUDENT_WORK_AT_OWN_PACE_ID]} color="green" />
      {tryItOutForYourself}
    </main>
  )
}

export default TeksPage
